module.exports = __webpack_public_path__ + "images/category_lp/watch/headline_sp_1a16877d1321a5752a89a524a44eaa8e.png";